<div class="strong-weak-sides-module row">
    <div class="col-6 strong-sides">
      <div class="title" >{{ 'lang.reporting.strongSides' | translate }}</div>
      <div *ngIf="strongestSides && strongestSides.length>0">
      <div  *ngFor="let item of strongestSides" class="question">
        {{ item }}
      </div></div>
    </div>
    <div class="col-6 weak-sides">
      <div class="title">{{ 'lang.reporting.weakSides' | translate }}</div>
      <div *ngIf="weakestSides && weakestSides.length>0">
      <div  *ngFor="let item of weakestSides" class="question">
      {{ item }}
      </div>
      </div>
    </div>
  </div>